//https://blog.logrocket.com/simplify-react-state-management-with-hookstate/
import { hookstate } from '@hookstate/core'

const globalSchoolStore = hookstate({
    IsActive: true
});

export default globalSchoolStore;